import { render, staticRenderFns } from "./PicacodeReleaseCreate.vue?vue&type=template&id=16a25446&"
import script from "./PicacodeReleaseCreate.vue?vue&type=script&lang=js&"
export * from "./PicacodeReleaseCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports